import { Config } from '../../../../config';

export const brsUrl = Config.isDeploymentTypeProd
  ? 'https://web-platform.snap.com'
  : 'https://auto-dot-bitmoji-reaction-service-dot-entapps-web-dev.gae.sc-corp.net';
